module.exports = __webpack_public_path__ + "img/read-img1.ace12361.png";